import React from 'react'
import { Container, Row, Col, Card} from "react-bootstrap";
import { FaInstagram, FaTwitter } from "react-icons/fa";



const About = () => {
  return (
    <>
<section style={{ background: "#efefef", padding: "70px 0", marginTop: "80px" }}>
  <Container>

   
    <h2
      className="text-center"
      style={{
        marginBottom: "20px",
        fontSize: "28px",
        fontFamily: "Montserrat, sans-serif",
        fontWeight: 800,
      }}
    >
      About  Sangam Guest House and Marriage Lawn
    </h2>

 <p className="text-center mt-2 mb-5 px-3 px-md-0 small fs-md-5 fs-lg-4">
  Discover the elegance and charm of our venue, where dream weddings come to life with personalized service and exquisite decor.
</p>

    <div className="row align-items-center">
      

      {/* <div className="col-lg-6 col-md-12">
        <p
          style={{
            fontSize: "1rem",
            lineHeight: "1.8",
            color: "#333",
            marginBottom: "30px",
            maxWidth: "520px",
          }}
        >
          Welcome to  Sangam Guest House and Marriage Lawn, your newest destination for creating
          beautiful and memorable weddings. Launched in 2026, we bring fresh
          ideas, personalized service, and modern decor to make your special day
          truly unforgettable.
        </p> */}
        <div className="col-lg-6 col-md-12">
  <p
    style={{
      fontSize: "1rem",
      lineHeight: "1.8",
      color: "#333",
      marginBottom: "30px",
      maxWidth: "100%",  
    }}
  >
    Welcome to Sangam Guest House and Marriage Lawn, your newest destination for creating
    beautiful and memorable weddings. Launched in 2026, we bring fresh
    ideas, personalized service, and modern decor to make your special day
    truly unforgettable.
  </p>


        <div className="row g-4">
          <div className="col-6">
            <h3 style={{ fontWeight: "700", color: "#000" }}>
              Innovative Designs
            </h3>
            <p style={{ color: "#444", lineHeight: "1.6" }}>
              We craft creative and unique wedding setups tailored to your style.
            </p>
          </div>

          <div className="col-6">
            <h3 style={{ fontWeight: "700", color: "#000" }}>
              Personalized Service
            </h3>
            <p style={{ color: "#444", lineHeight: "1.6" }}>
              Every couple receives customized attention for a seamless experience.
            </p>
          </div>

          <div className="col-6">
            <h3 style={{ fontWeight: "700", color: "#000" }}>
              Modern Approach
            </h3>
            <p style={{ color: "#444", lineHeight: "1.6" }}>
              We combine contemporary trends with timeless elegance for every event.
            </p>
          </div>

          <div className="col-6">
            <h3 style={{ fontWeight: "700", color: "#000" }}>
              Dedicated Team
            </h3>
            <p style={{ color: "#444", lineHeight: "1.6" }}>
              Passionate coordinators and designers committed to perfection.
            </p>
          </div>
        </div>
      </div>


      <div className="col-lg-6 col-md-12 text-center">
        <img
          src="https://images.unsplash.com/photo-1519167758481-83f550bb49b3?q=80&w=1200&auto=format&fit=crop"
          alt="Wedding Hall"
          className="img-fluid"
          style={{
            borderRadius: "6px",
            width: "100%",
            maxWidth: "600px",
            objectFit: "cover",
          }}
        />
      </div>

    </div>
  </Container>
</section>

{/* 
      <section style={{ background: "#efefef", padding: "50px 0" }}>
        <Container>
          <h2 className="fw-bold">Get in Touch</h2>
          <p className="text-muted mb-4">
            Contact us today to start planning your perfect wedding experience.
          </p>

          <Button
            style={{
              background: "#fff",
              color: "#000",
              border: "1px solid #000",
              borderRadius: "0",
              padding: "8px 20px",
            }}
          >
            Learn More
          </Button>
        </Container>
      </section> */}
    </>
  )
}

export default About
